//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Creates new file
 * @param comment (optional) 
 * @param dataBlockId (optional) 
 * @param patientId (optional) 
 * @param importId (optional) 
 * @param templateId (optional) 
 * @param start (optional) 
 * @param file (optional) 
 */
export function create(type: Types.FileType, comment?: string | null | undefined, dataBlockId?: number | null | undefined, patientId?: number | null | undefined, importId?: string | null | undefined, templateId?: number | null | undefined, start?: Date | null | undefined, file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto> {
    let url_ = getBaseUrl() + "/api/files?";
      if (type === undefined || type === null)
        throw new Error("The parameter 'type' must be defined and cannot be null.");
      else
        url_ += "type=" + encodeURIComponent("" + type) + "&";
    if (comment !== undefined && comment !== null)
        url_ += "comment=" + encodeURIComponent("" + comment) + "&";
    if (dataBlockId !== undefined && dataBlockId !== null)
        url_ += "dataBlockId=" + encodeURIComponent("" + dataBlockId) + "&";
    if (patientId !== undefined && patientId !== null)
        url_ += "patientId=" + encodeURIComponent("" + patientId) + "&";
    if (importId !== undefined && importId !== null)
        url_ += "importId=" + encodeURIComponent("" + importId) + "&";
    if (templateId !== undefined && templateId !== null)
        url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
    if (start !== undefined && start !== null)
        url_ += "start=" + encodeURIComponent(start ? "" + start.toISOString() : "") + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.FileInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initFileInfoDto(resultData200);
        return Promise.resolve<Types.FileInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto>(null as any);
}

/**
 * Returns a list of files according to search criteria.
If IsAllVersions is false (or not set, by default),
returns only the Files with IsLatestVersion true.
 * @param patientId (optional) We have separate PatientId and PatientIds fields to make it easier to invalidate react-queries by patient id
 * @param dataBlockId (optional) 
 * @param patientIds (optional) 
 * @param fileNames (optional) 
 * @param importIds (optional) 
 * @param fileType (optional) 
 * @param excludeFileType (optional) 
 * @param isAllVersions (optional) 
 * @param fileIds (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeTransportStatuses (optional) 
 */
export function searchFiles(patientId?: number | null | undefined, dataBlockId?: number | null | undefined, patientIds?: number[] | null | undefined, fileNames?: string[] | null | undefined, importIds?: string[] | null | undefined, fileType?: Types.FileType | null | undefined, excludeFileType?: Types.FileType[] | null | undefined, isAllVersions?: boolean | null | undefined, fileIds?: string[] | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeTransportStatuses?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto[]> {
    let url_ = getBaseUrl() + "/api/files?";
    if (patientId !== undefined && patientId !== null)
        url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
    if (dataBlockId !== undefined && dataBlockId !== null)
        url_ += "DataBlockId=" + encodeURIComponent("" + dataBlockId) + "&";
    if (patientIds !== undefined && patientIds !== null)
        patientIds && patientIds.forEach(item => { url_ += "PatientIds=" + encodeURIComponent("" + item) + "&"; });
    if (fileNames !== undefined && fileNames !== null)
        fileNames && fileNames.forEach(item => { url_ += "FileNames=" + encodeURIComponent("" + item) + "&"; });
    if (importIds !== undefined && importIds !== null)
        importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (fileType !== undefined && fileType !== null)
        url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
    if (excludeFileType !== undefined && excludeFileType !== null)
        excludeFileType && excludeFileType.forEach(item => { url_ += "ExcludeFileType=" + encodeURIComponent("" + item) + "&"; });
    if (isAllVersions !== undefined && isAllVersions !== null)
        url_ += "IsAllVersions=" + encodeURIComponent("" + isAllVersions) + "&";
    if (fileIds !== undefined && fileIds !== null)
        fileIds && fileIds.forEach(item => { url_ += "FileIds=" + encodeURIComponent("" + item) + "&"; });
    if (values !== undefined && values !== null)
        values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
    if (includeTransportStatuses !== undefined && includeTransportStatuses !== null)
        url_ += "IncludeTransportStatuses=" + encodeURIComponent("" + includeTransportStatuses) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSearchFiles,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigSearchFiles?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSearchFiles(_response);
    });
}

function processSearchFiles(response: AxiosResponse): Promise<Types.FileInfoDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initFileInfoDto(item)
              );
            }
        return Promise.resolve<Types.FileInfoDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto[]>(null as any);
}

/**
 * Updates a file by either:
- adding a new version of a given file (if the file doesn't have a Draft)
- updating a Draft (if a Draft exists)
 * @param fileId Id of any file in a Group (or GroupId itself)
 * @param file (optional) 
 * @return A new version or a Draft
 */
export function updateFile(fileId: string, file?: Types.FileParameter | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto> {
    let url_ = getBaseUrl() + "/api/files/{fileId}";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
        content_.append("file", file.data, file.fileName ? file.fileName : "file");

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateFile,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdateFile?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateFile(_response);
    });
}

function processUpdateFile(response: AxiosResponse): Promise<Types.FileInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initFileInfoDto(resultData200);
        return Promise.resolve<Types.FileInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto>(null as any);
}

/**
 * Publishes draft version, returns published version
 * @return Published version
 */
export function publishDraft(fileId: string, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto> {
    let url_ = getBaseUrl() + "/api/files/{fileId}/draft/publish";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPublishDraft,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPublishDraft?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPublishDraft(_response);
    });
}

function processPublishDraft(response: AxiosResponse): Promise<Types.FileInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initFileInfoDto(resultData200);
        return Promise.resolve<Types.FileInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto>(null as any);
}

export function patchFile(id: string, dto: Types.PatchFileDto, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto> {
    let url_ = getBaseUrl() + "/api/files/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializePatchFileDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPatchFile,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigPatchFile?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPatchFile(_response);
    });
}

function processPatchFile(response: AxiosResponse): Promise<Types.FileInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initFileInfoDto(resultData200);
        return Promise.resolve<Types.FileInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto>(null as any);
}

/**
 * Return literal file data of a given file version
 * @param fileId Id of a exact file version to be downloaded
 * @param timestamp (optional) Optional. You could pass any string to avoid caching on the frontend
 */
export function downloadFile(fileId: string, timestamp?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/files/{fileId}/data?";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    if (timestamp === null)
        throw new Error("The parameter 'timestamp' cannot be null.");
    else if (timestamp !== undefined)
        url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        responseType: "blob",
        ..._requestConfigDownloadFile,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigDownloadFile?.headers,
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDownloadFile(_response);
    });
}

function processDownloadFile(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

/**
 * Get version history of a file
 * @param groupId Id of a file group. GroupId
 */
export function getVersionHistory(groupId: string, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto[]> {
    let url_ = getBaseUrl() + "/api/files/{groupId}/history";
    if (groupId === undefined || groupId === null)
      throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetVersionHistory,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetVersionHistory?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetVersionHistory(_response);
    });
}

function processGetVersionHistory(response: AxiosResponse): Promise<Types.FileInfoDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initFileInfoDto(item)
              );
            }
        return Promise.resolve<Types.FileInfoDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto[]>(null as any);
}

export function getFileInfo(fileId: string, includeTransportStatuses?: boolean | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileInfoDto> {
    let url_ = getBaseUrl() + "/api/files/{fileId}/info?";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    if (includeTransportStatuses !== undefined && includeTransportStatuses !== null)
        url_ += "IncludeTransportStatuses=" + encodeURIComponent("" + includeTransportStatuses) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetFileInfo,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetFileInfo?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetFileInfo(_response);
    });
}

function processGetFileInfo(response: AxiosResponse): Promise<Types.FileInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initFileInfoDto(resultData200);
        return Promise.resolve<Types.FileInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileInfoDto>(null as any);
}

export function deleteFile(groupId: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/files/{groupId}";
    if (groupId === undefined || groupId === null)
      throw new Error("The parameter 'groupId' must be defined.");
    url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteFile,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteFile?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteFile(_response);
    });
}

function processDeleteFile(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function deleteVersion(versionId: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/files/versions/{versionId}";
    if (versionId === undefined || versionId === null)
      throw new Error("The parameter 'versionId' must be defined.");
    url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteVersion,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteVersion?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteVersion(_response);
    });
}

function processDeleteVersion(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Send file by email.
 * @param subtenantId (optional) 
 */
export function sendFileByEmail(fileId: string, subtenantId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/files/{fileId}/send-by-email?";
    if (fileId === undefined || fileId === null)
      throw new Error("The parameter 'fileId' must be defined.");
    url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
    if (subtenantId === null)
        throw new Error("The parameter 'subtenantId' cannot be null.");
    else if (subtenantId !== undefined)
        url_ += "subtenantId=" + encodeURIComponent("" + subtenantId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSendFileByEmail,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSendFileByEmail?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSendFileByEmail(_response);
    });
}

function processSendFileByEmail(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigSearchFiles: Partial<AxiosRequestConfig> | null;
export function getSearchFilesRequestConfig() {
  return _requestConfigSearchFiles;
}
export function setSearchFilesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSearchFiles = value;
}
export function patchSearchFilesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSearchFiles = patch(_requestConfigSearchFiles ?? {});
}

let _requestConfigUpdateFile: Partial<AxiosRequestConfig> | null;
export function getUpdateFileRequestConfig() {
  return _requestConfigUpdateFile;
}
export function setUpdateFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateFile = value;
}
export function patchUpdateFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateFile = patch(_requestConfigUpdateFile ?? {});
}

let _requestConfigPublishDraft: Partial<AxiosRequestConfig> | null;
export function getPublishDraftRequestConfig() {
  return _requestConfigPublishDraft;
}
export function setPublishDraftRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPublishDraft = value;
}
export function patchPublishDraftRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPublishDraft = patch(_requestConfigPublishDraft ?? {});
}

let _requestConfigPatchFile: Partial<AxiosRequestConfig> | null;
export function getPatchFileRequestConfig() {
  return _requestConfigPatchFile;
}
export function setPatchFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPatchFile = value;
}
export function patchPatchFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPatchFile = patch(_requestConfigPatchFile ?? {});
}

let _requestConfigDownloadFile: Partial<AxiosRequestConfig> | null;
export function getDownloadFileRequestConfig() {
  return _requestConfigDownloadFile;
}
export function setDownloadFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDownloadFile = value;
}
export function patchDownloadFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDownloadFile = patch(_requestConfigDownloadFile ?? {});
}

let _requestConfigGetVersionHistory: Partial<AxiosRequestConfig> | null;
export function getGetVersionHistoryRequestConfig() {
  return _requestConfigGetVersionHistory;
}
export function setGetVersionHistoryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetVersionHistory = value;
}
export function patchGetVersionHistoryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetVersionHistory = patch(_requestConfigGetVersionHistory ?? {});
}

let _requestConfigGetFileInfo: Partial<AxiosRequestConfig> | null;
export function getGetFileInfoRequestConfig() {
  return _requestConfigGetFileInfo;
}
export function setGetFileInfoRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetFileInfo = value;
}
export function patchGetFileInfoRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetFileInfo = patch(_requestConfigGetFileInfo ?? {});
}

let _requestConfigDeleteFile: Partial<AxiosRequestConfig> | null;
export function getDeleteFileRequestConfig() {
  return _requestConfigDeleteFile;
}
export function setDeleteFileRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteFile = value;
}
export function patchDeleteFileRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteFile = patch(_requestConfigDeleteFile ?? {});
}

let _requestConfigDeleteVersion: Partial<AxiosRequestConfig> | null;
export function getDeleteVersionRequestConfig() {
  return _requestConfigDeleteVersion;
}
export function setDeleteVersionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteVersion = value;
}
export function patchDeleteVersionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteVersion = patch(_requestConfigDeleteVersion ?? {});
}

let _requestConfigSendFileByEmail: Partial<AxiosRequestConfig> | null;
export function getSendFileByEmailRequestConfig() {
  return _requestConfigSendFileByEmail;
}
export function setSendFileByEmailRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSendFileByEmail = value;
}
export function patchSendFileByEmailRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSendFileByEmail = patch(_requestConfigSendFileByEmail ?? {});
}